import {Component, input, InputSignal, output} from '@angular/core';
import {
  AssemblyGraphicalConfiguratorComponent
} from "./assembly-graphical-configurator/assembly-graphical-configurator.component";
import {
  AssemblySpreadsheetConfiguratorComponent
} from "./assembly-spreadheet-configurator/assembly-spreadsheet-configurator.component";

import {LamelareaImpl} from "../shared/product-card/product-card/lamelarea.class";

type ConfigurationModes = 'graphical' | 'spreadsheet' | 'both';

@Component({
  selector: 'app-assembly-configurator',
  standalone: true,
  imports: [
    AssemblyGraphicalConfiguratorComponent,
    AssemblySpreadsheetConfiguratorComponent
  ],
  templateUrl: './assembly-configurator.component.html',
  styleUrl: './assembly-configurator.component.scss',
  styles:  ":host{ @apply block relative ; }"
})
export class AssemblyConfiguratorComponent {

  /**
   * store provided lamella area
   */
  public lamellaArea: InputSignal<LamelareaImpl> = input();

  /**
   * Mode of the assembly configurator
   * @protected
   */
  public mode: InputSignal<ConfigurationModes> = input('graphical', { transform: (value) => value as ConfigurationModes });

}